import Image from 'next/image'
import React from 'react'
import SectionHeading from './../Common/SectionHeading'
export default function WhatWeDo({data}) {
  return (
    <>
    <div className="flex flex-col justify-center w-11/12 mx-auto my-4 xl:max-w-screen max-w-screen-2xl lg:my-8">
      <SectionHeading 
        title={data?.title}
        
        customClass="text-center"
      />
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 lg:col-span-4">
          <div className='lg:p-6 p-4 bg-[#1b5df3] dark:bg-gray-600 text-white rounded-xl rounded-br-[100px]'>
              <h3 className='text-lg font-semibold'>{data?.firstTitle}</h3>
              <p className='text-base text-left'>
                {data?.firstDescription}
              </p>
          </div>
        </div>
        <div className="col-span-12 md:col-span-6 lg:col-span-4">
          <>
            <div className='overflow-hidden rounded-xl'>
              <Image priority={false} 
                alt={data?.second?.title}
                src={process.env.IMG_CDN+data?.second?.imageSrc}
                height={2000}
                width={2000}
                className="object-cover w-full transition duration-500 cursor-pointer rounded-xl hover:scale-110"
              />
            </div>
            <h3 className="text-lg font-semibold py-2 text-[#1b5df3]">{data?.second?.title}</h3>
            <p className="my-0 text-base"> {data?.second?.description}</p>
          </>
        </div>
        <div className="col-span-12 md:col-span-6 lg:col-span-4">
          <>
          <div className='overflow-hidden rounded-xl'>
            <Image priority={false} 
                alt={data?.third?.title}
                src={process.env.IMG_CDN+data?.third?.imageSrc}
                height={2000}
                width={2000}
                className="object-cover w-full transition duration-500 cursor-pointer rounded-xl hover:scale-110"
              />
          </div>
            <h3 className="text-lg font-semibold py-2 text-[#1b5df3]">{data?.third?.title}</h3>
            <p className="my-0 text-base"> {data?.third?.description}</p>
          </>
        </div>
      </div>
    </div>
    </>
  )
}
